import { environmentConfig } from "@src/appV2/environment";
import { DeploymentEnvironmentName } from "@src/appV2/environment/types";

const LOCALHOST_ORIGIN = "http://localhost:3000";

export function getAllowedImpersonationOrigins(): Set<string> {
  const origins = new Set<string>();

  const configuredUrl = environmentConfig.REACT_APP_ADMIN_WEB_APP_URL;
  if (configuredUrl) {
    origins.add(new URL(configuredUrl).origin);
  }

  if (environmentConfig.REACT_APP_ENVIRONMENT_NAME !== DeploymentEnvironmentName.PRODUCTION) {
    origins.add(LOCALHOST_ORIGIN);
  }

  return origins;
}
